import { useEffect, useState } from 'react';
import classes from './ExceptionalOpeningModal.module.css';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Modal from '../../../../components/UI/Modals/Modal';
import { useAppDispatch, useAppSelector } from '../../../../store/store';
import {
  selectCalendarAndSlots,
  updateCalendarAndSlotsState,
} from '../../../../store/slices/calendarAndSlots';

import PrimaryButtonV2 from '../../../../components/UI/Buttons/PrimaryButtonV2';
import { useTranslation } from '../../../../hooks/useTranslations';
import { enGB, es, de, fr } from 'date-fns/locale';



  
const localeMap: any = {
  en: enGB,
  es: es,
  de: de,
  fr: fr,
};
type Props = {
  isOpen: boolean;
  onClose: () => void;
  item: any;
  index: number | undefined;
};

const ExceptionalOpeningModal: React.FC<Props> = ({ isOpen, onClose, item, index }) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const [startDate, setStartDate] = useState<Date | undefined>();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const calendarAndSlots = useAppSelector<any>(selectCalendarAndSlots);
  let calendarData: any = Array(calendarAndSlots);
  let calendarItems = [...calendarData[0].exceptional_openings];
  
  const lang = localStorage.getItem('lang') || 'en';



  const handleAddOrUpdate = async (indexToUpdate: number | undefined) => {
    const newCalendarItem = {
      opening_date: moment(startDate).format('YYYY-MM-DD'),
      start_time: from,
      end_time: to,
    };
    if (indexToUpdate !== undefined && indexToUpdate < calendarItems.length) {
      calendarItems[indexToUpdate] = newCalendarItem;
    } else {
      calendarItems.push(newCalendarItem);
    }

    let dataToPost = [
      {
        ...calendarData[0],
        exceptional_openings: calendarItems,
      },
    ];

    dispatch(updateCalendarAndSlotsState(dataToPost[0]));
    onClose();
  };

  useEffect(() => {
    if (item) {
      setStartDate(new Date(item.opening_date));
      setFrom(item.start_time);
      setTo(item.end_time);
    } else {
      setFrom('');
      setTo('');
      setStartDate(undefined);
    }
  }, [isOpen]);
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      containerPadding="20px 10px"
      width="350px"
      header={translations('exceptional.opening').toString()}
    >
      <div className={classes.modalContainer}>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('day.month.year')}</div>
          <DatePicker
            dateFormat="dd.MM.yyyy"
            selected={startDate}
            className={classes.datepicker}
            onChange={(date: Date) => setStartDate(date)}
            locale={localeMap[lang]}

          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('from')}</div>
          <input
            id="appt-time"
            type="time"
            name="appt-time"
            className={classes.textContainer}
            onChange={(e) => setFrom(e.target.value + ':00')}
            value={from}
          />
        </div>
        <div className={classes.inputContainer}>
          <div className={classes.text}>{translations('to')}</div>
          <input
            id="appt-time"
            type="time"
            name="appt-time"
            className={classes.textContainer}
            onChange={(e) => setTo(e.target.value + ':00')}
            value={to}
          />
        </div>
        <PrimaryButtonV2
          buttonStyle={{ width: 270, marginTop: 40 }}
          text={translations('add')}
          containerStyle={{}}
          disabled={false}
          onClick={() => handleAddOrUpdate(index)}
        />
      </div>
    </Modal>
  );
};

export default ExceptionalOpeningModal;
